import { type invertedMessages } from '../utils/messages';

/**
 * TODO: NodeJS upgrade with microfrontend architecture - Move these to environemnt variables once a separate pod will be created for this.
 */
const config = {
  USE_LOCAL_MOCK_API: false,
  DASHBOARD_URL: '/intelligence/ispm/dashboard',
  RESET_ENTRY: {
    userQuery: 'Reset chat' as keyof typeof invertedMessages,
    response: 'Sure, How can I help?' as keyof typeof invertedMessages,
  },
  MAX_CHARTS_TO_STORE: 2,
  MAX_TABLES_TO_STORE: 1,
};

export default config;
